import { Collection, CollectionPrinter } from "@tblabs/truffle";
import { GalleryItemEditor } from "./GalleryItemEditor";
import { OnlineStorage } from "./OnlineStorage";
import { Page } from "../Pages/Page";
import { PicsUploader } from "./PicsUploader";
import { PicturePack } from "./PicturePack";
import { PicturePackToGalleryItemConverter } from "./PicturePackToGalleryItemConverter";
import { GalleryItem } from "./GalleryItem";
import { Logger } from "../Components/Logger";
import { AuthService } from "../Services/AuthService";


export class DemoPage extends Page
{
    constructor(private _auth: AuthService, private _logger: Logger)
    {
        super("Demo config");

        if (!this._auth.IsLoggedIn)
        {
            this._logger.Log("Not logged in. Redirecting to login page...");
            window.location.href = "/login";
        }
    }

    protected async OnAppend(): Promise<void>
    {
        const storage = new OnlineStorage("https://photos.specteam.pl", this._auth.PhotosServerAuthToken);
        const dir = "tx-demo";

        const items = new Collection<GalleryItem>()
            .OnRemove(async (item) =>  await storage.Delete(dir, item.Name));

        const picsUploader = new PicsUploader(storage, dir,
            (info: PicturePack[]) =>
            {
                const galleryItems = PicturePackToGalleryItemConverter.ConvertMany(info);
                items.Add(...galleryItems.Items);
            });

        const existingFiles = await storage.GetFiles(dir);
        const galleryItems = PicturePackToGalleryItemConverter.ConvertMany(existingFiles);
        items.Add(...galleryItems.Items);


        this.body.Append(
            picsUploader,
            new CollectionPrinter(items, x => new GalleryItemEditor(x, items))
        );
    }
}
